<template>
    <div>
        <div class="bg-overlay"></div>
        <div class="favorites-form favorites-share">
            <span class="close" @click="hideShare()"></span>
            <div v-if="!submitted">
                <h3>{{ trans('talents.selection_share.title') }}</h3>
                <form id="form-submit" class="form-validate">
                    <div :class="{'input-row': true, 'error': errors.has('name') }">
                        <label for="name">{{ trans('talents.selection_share.name') }}</label>
                        <input id="name" name="name" type="text">
                        <span v-show="errors.has('name')" class="error">{{ errors.first('name') }}</span>
                    </div>
                    <div :class="{'input-row': true, 'error': errors.has('email') }">
                        <label for="email">{{ trans('talents.selection_share.email') }}</label>
                        <input v-validate="'required|email'" data-vv-delay="1500" class="required" id="email" name="email" type="text">
                        <span v-show="errors.has('email')" class="error">{{ errors.first('email') }}</span>
                    </div>
                    <div :class="{'input-row': true, 'error': errors.has('name') }">
                        <label for="your_email">{{ trans('talents.selection_share.your_email') }}</label>
                        <input v-validate="'required|email'" data-vv-delay="1500" class="required" id="your_email" name="your_email" type="text">
                        <span v-show="errors.has('your_email')" class="error">{{ errors.first('your_email') }}</span>
                    </div>
                    <label for="remarks">{{ trans('talents.selection_share.comments') }}</label>
                    <textarea id="remarks"></textarea>
                    <span class="btn-orange btn-send-submit" @click.prevent="validateForm()">{{ trans('talents.selection_share.send') }}</span>
                </form>
            </div>
            <div v-if="submitted">
                <h3>{{ trans('talents.selection_share.success_title') }}</h3>
                <p>{{ trans('talents.selection_share.success_text') }}</p>
            </div>
        </div>
    </div>
</template>
<script type='text/babel'>
    import {mapState} from 'vuex'
    import FloatLabels from 'float-labels.js'

    export default {
        data: function () {
            return {
                submitted: false,
            }
        },
        mounted() {
            window.addEventListener('keyup', ev => {
                if (ev.keyCode === 27) {
                    this.hideShare()
                }
            })
            new FloatLabels('form', {requiredClass: 'required'});
            this.$validator.localize('en');
        },
        computed: {},
        watch: {},
        methods: {
            hideShare() {
                this.$parent.$emit('hideShare')
            },
            validateForm() {
                this.$validator.validateAll().then(() => {
                    if (!this.errors.any()) {
                        this.submitted = true
                        //this.hideShare()
                    }
                });
            }
        },
    };
</script>